import { useCallback, useEffect, useState } from "react";
import { axiosRequest } from "../utility/axios.js";

export function useAxiosFetch(method, url, token, payload = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // const res = await api.get(url, options);
      const res = await axiosRequest(method, url, token, payload);
      
      setData(res.data.data ?? res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
